import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {IoniconsOutline, SessionInfoType, SessionNotification, SessionNotificationStatus} from '@pt/pt-models';
import {DownloadService} from '@pt/api-client';
import {ID_SESSION_NOTIFICATION} from '../../utils/resolution-checker';
import {SubmitDownloadResponse} from "it/primatoo/openapi/api/org/schemas/common/docs/SubmitDownloadResponse";

@Component({
  selector: 'pt-session-notification',
  template: `
    <div class="session-notification" [id]="ID">
      <header>
        <button
          class="btn-custom-close"
          type="button"
          (click)="closeSessionNotification.emit()"
        >
          <pt-icon [size]="25" [key]="IconClose"></pt-icon>
        </button>
      </header>

      <div>
        <div class="session-notification-action-panel">
          <span class="title">{{ 'TITLE.NOTIFICATIONS' | translate }}</span>
          <button
            class="btn btn-link btn-sm ms-auto"
            [disabled]="infoNotification?.length === 0"
            type="button"
            (click)="deleteAll()"
          >
            {{ 'BUTTON.DELETE_ALL' | translate }}
          </button>
        </div>

        <ng-container
          *ngFor="let sessionNotification of downloadNotification; index as idx"
        >
          <pt-session-notification-item
            [index]="idx"
            [sessionNotification]="sessionNotification"
            (openNotification)="openSessionInfo(sessionNotification)"
            (closeSessionNotification)="
              deleteSessionNotification.emit([sessionNotification])
            "
          ></pt-session-notification-item>
        </ng-container>
      </div>

      <p class="mx-1" *ngIf="downloadNotification?.length === 0">
        {{ 'MESSAGE.NO_NEW_NOTIFICATION' | translate }}
      </p>
    </div>
  `,
  styleUrls: ['session-notification.component.scss'],
})
export class SessionNotificationComponent implements OnChanges {
  @Input() sessionNotifications: SessionNotification[];
  @Output() closeSessionNotification = new EventEmitter<boolean>();
  @Output() deleteSessionNotification = new EventEmitter<
    SessionNotification[]
  >();
  downloadNotification: SessionNotification[];
  infoNotification: SessionNotification[];
  ID = ID_SESSION_NOTIFICATION;
  IconClose = IoniconsOutline.close;

  constructor(private downloadService: DownloadService) {}

  openSessionInfo(sessionInfo: SessionNotification) {
    if (
      (sessionInfo.status === SessionNotificationStatus.COMPLETED ||
        sessionInfo.status === SessionNotificationStatus.PARTIAL_COMPLETED) &&
      sessionInfo.actionType === SessionInfoType.DOWNLOAD
    ) {
      this.downloadService.downloadComplete(
        (sessionInfo.payload as SubmitDownloadResponse).uuid
      );
    }
  }

  deleteAll() {
    this.deleteSessionNotification.emit(this.sessionNotifications);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sessionNotifications) {
      // this.downloadNotification = this.sessionNotifications?.filter((n) => n.actionType === SessionInfoType.DOWNLOAD)
      this.downloadNotification = this.sessionNotifications;
    }
  }
}
